import React, { Component } from 'react';
import PropTypes from 'prop-types';

const initialState = {
  left: -9999,
  top: -9999,
  width: 'auto',
  height: 'auto'
};

class CroppedImage extends Component {
  constructor() {
    super();
    this.handleImageLoaded = this.handleImageLoaded.bind(this);

    this.state = initialState;
  }

  componentWillReceiveProps(props) {
    const { container } = this.refs;
    if (this.props.src !== props.src) {
      this.setState(initialState);
    }
    if (container && container.style && container.style.hasOwnProperty('background')) {
      container.style.removeProperty('background');
    }
  }

  handleImageLoaded() {
    const { width, height } = this.props;
    const { container, image } = this.refs;

    const containerSize = {
      width: width || container.offsetWidth,
      height: height || container.offsetHeight
    };

    const imageSize = {
      width: image.offsetWidth,
      height: image.offsetHeight
    };

    const imageRatio = imageSize.width / imageSize.height;
    const containerRatio = containerSize.width / containerSize.height;

    if (imageRatio > containerRatio) {
      const resizedWidth = containerSize.height * imageRatio;
      this.setState({
        left: (containerSize.width - resizedWidth) / 2,
        top: 0,
        width: resizedWidth,
        height: containerSize.height
      });
    } else {
      const resizedHeight = containerSize.width / imageRatio;
      this.setState({
        left: 0,
        top: (containerSize.height - resizedHeight) / 2,
        width: containerSize.width,
        height: resizedHeight
      });
    }

    container.style.background = 'initial';
  }

  render() {
    const { className, src, dimmed } = this.props;
    const classNames = [];
    const { left, top, width, height } = this.state;

    if (className) {
      classNames.push(className);
    }

    return (
      <span ref="container" className={classNames.join(' ')}>
        <img ref="image"
          src={src}
          className="img_g"
          style={{ left, top, width, height }}
          onLoad={this.handleImageLoaded}
        />
        {dimmed === 'used' && (
          <span className="thumb_dim">
            <em className="dim_txt">사용</em>
            <em className="dim_txt">완료</em>
          </span>
        )}
        {dimmed === 'outDated' && (
          <span className="thumb_dim">
            <em className="dim_txt">기간</em>
            <em className="dim_txt">만료</em>
          </span>
        )}
      </span>
    );
  }
}

CroppedImage.propTypes = {
  src: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  dimmed: PropTypes.string
};

export default CroppedImage;



// WEBPACK FOOTER //
// ./src/components/CroppedImage/index.js